// arg が数値であることを確認する
// ゼロ埋めの値は false
// 空文字列は false
// NaN は false
// Infinity は false
// undefined は false
// 小数点を含む値は true
// マイナスが接頭している値は true
export function isNumberAllowDecimal(x) {
  return /^[-]?([0-9]\d*|0)(\.\d+)?$/.test(x)
}
// arg が数値であることを確認する
// ゼロ埋めの値は false
// 空文字列は false
// NaN は false
// Infinity は false
// undefined は false
// 小数点を含む値は true
// マイナスが接頭している値は false
export function isNumberAllowDecimalNotMinus(x) {
  return /^([0-9]\d*|0)(\.\d+)?$/.test(x)
}
// 小数点以下の桁数を得る
// isNumberAllowDecimal が通過している前提 (NaN, Infinityなど考慮しない)
export function getNumDecimalPlace(x) {
  const target = String(x).split('.');
  // 整数であれば numbers[1] はない
  return (target[1]) ? target[1].length : 0;
}
